<template>
    <v-empty-state v-bind:headline="`HTTP ${error.statusCode} - ${$t('000-headline')}`"
                   v-bind:title="$t('000-title')"
                   v-bind:text="$t('000-text')"
                   v-bind:image="imgUrl" />
</template>

<script setup lang="ts">
    // LOCAL TRANSLATIONS
    const messages = {
        sv: {
            '000-headline': 'Något gick fel!',
            '000-title': 'Det inträffade ett oväntat fel. Sidan du försökte nå kunde inte visas just nu.',
            '000-text': 'Försök igen om en stund, eller gå tillbaka till startsidan.',
        },
        en: {
            '000-headline': 'Something went wrong!',
            '000-title': 'An unexpected error occurred. The page you were trying to reach could not be displayed.',
            '000-text': 'Please try again later, or return to the homepage.',
        }
    };

    // PROPS
    const props = defineProps({
        error: Object as () => NuxtError,
        imgUrl: String
    });

    const {
        $i18n
    } = useNuxtApp();

    onMounted(() => {
        $i18n.mergeLocaleMessage($i18n.locale.value, messages[$i18n.locale.value]);
    });
</script>